import { FileState, UploadedFile } from '@shared/types/input-file';
import { IFileData } from '@vtbhome/juicyfront/types';

export type LocalFile = IFileData & FileState;

export interface InputFileSearchValue {
    /* Уже существующие файлы */
    initialUploadedFiles: UploadedFile[];
    /* Удаленные существующие файлы */
    deletedUploadedFiles: UploadedFile[];
    /* Добавленные существующие файлы */
    addedUploadedFiles: UploadedFile[];
    /* Локально загруженные новые файлы */
    localFiles: LocalFile[];
    /* Локально загруженные новые файлы */
    filesQueue: (LocalFile | UploadedFile)[];
}

export interface InputFileSearchProps {
    required?: boolean;
    disabled?: boolean;
    accept?: string;
    hint?: string;
    name?: string;
    selectLabel?: string;
    selectPlaceholder?: string;
    label?: string;
    placeholderLocalInput?: string | JSX.Element;
    placeholderSearchInput?: string | JSX.Element;
    error?: string;
    value: InputFileSearchValue;
    max?: number;
    onChange?: (value: InputFileSearchValue) => void;
}

export enum INPUT_TYPE {
    Upload = 'upload',
    Search = 'search',
}
